<template>
    <div :class="spacingClasses"
         class="animate-pulse loader mb-48">
        <div v-for="index in amount"
             :class="[
                 paddingClasses,
                 {'pl-64 pr-20' : showAvatar},
                 {'rounded bg-white shadow-md' : type === 'box'}
             ]"
             class="w-full">
            <div class="flex items-center space-x-24">
                <div v-if="showAvatar" class="bg-primary-20 rounded-32 h-60 w-60"></div>
                <div class="flex-1">
                    <div class="bg-primary-20 h-10 rounded w-3/4"></div>
                    <div class="bg-primary-20 h-10 rounded w-5/6 mt-14"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        amount: {
            type: Number,
            default: 1,
        },
        type: {
            type: String,
            default: 'list',
        },
        showAvatar: {
            // show an avatar as placeholder
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: 'normal',
            validator: value => ['small', 'normal', 'big'].includes(value),
        },
    },
    computed: {
        spacingClasses() {
            return {
                small: '',
                normal: 'space-y-12',
                big: 'space-y-16',
            }[this.size];
        },
        paddingClasses() {
            return {
                small: 'p-14',
                normal: 'p-24',
                big: 'py-56 px-24',
            }[this.size];
        },
    },
};
</script>